module.exports = __webpack_public_path__ + "static/media/hubspotProcess1.75542db2.png";